import React, { Component } from 'react'
import styled from 'styled-components'
import { formatCode, updateDiaognistics } from '../lib'

const getSuggestionTypeText = (suggestionType) => {
  switch (suggestionType) {
    case 'PL':
      return 'on problem list'
    case 'ED':
      return "one of today's problems"
    default:
      return ''
  }
}

const Container = styled.div`
    width: 100%;
    max-width: 400px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    margin: 10px auto;
    .header {
        height: 40px;
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        background-color: #f4f7f7;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-container {
        max-height: 300px;
        overflow: auto;
    }
`

const SuggestionItem = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;

    &:hover {
        cursor: pointer;
        background-color: rgba(240, 244, 239, 0.5);
    }
    .meta {
        max-width: 300px;

        .description {
            font-size: 16px;
            color: black;
            max-width: 300px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 600;
  
        }
        .suggestion-type {
            font-size: 12px;
            color: #176063;
        }
    }

`

const ICD10Code = styled.div`
  border-radius: 5px;
  border: 0;
  height: 30px;
  width: 55px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;

  color: rgba(0, 0, 0, 0.5);
  background-color: rgba(240, 244, 239, 0.75);
`

class HCCSuggestionsPanel extends Component {
    addDiagnosis = async (diagnosis) => {
      const { icdCode, snomedCode, billable, description, problemLabel } = diagnosis
      const { section, handleAddDiagnosis } = this.props
      const newSection = { ...section }
      newSection.name = problemLabel
      newSection.diagnosisEntry = {
        diagnosis: {
          icdCode,
          snomedCode,
          billable,
          description,
          problemLabel
        },
        confirmStatus: 'CONFIRMED'
      }

      newSection.updateType = 'WHOLE'
      await updateDiaognistics(newSection)
      handleAddDiagnosis()
    }

    render () {
      const { hccSuggestions } = this.props

      const suggestionList = hccSuggestions.map((suggestion, i) => {
        const { diagnosis, suggestionType } = suggestion
        const { icdCode, snomedDescription, problemLabel } = diagnosis
        return (
          <SuggestionItem
            key={icdCode}
            onClick={() => this.addDiagnosis(diagnosis)}
          >
            <div className='meta' data-cy={`hcc-suggestion-${i}`}>
              <div className='description'>{problemLabel || snomedDescription}</div>
              <div className='suggestion-type'>{getSuggestionTypeText(suggestionType)}</div>
            </div>
            <ICD10Code data-cy={`suggestion-code-${i}`}>{formatCode(icdCode) || 'No Code'}
            </ICD10Code>
          </SuggestionItem>
        )
      })

      return (
        <Container
          id='hcc-suggestions-panel'
          data-cy='hcc-suggestion-panel'
        >
          <div className='header'>
                Problems
          </div>
          <div className='list-container'>
            {suggestionList}
          </div>
        </Container>
      )
    }
}

export default HCCSuggestionsPanel
